export interface ServiceProvidersState {
  service_providers: ServiceProvider[]
  serviceProviderItem?:ServiceProviderItem[]
}

export interface ServiceProvider {
  id: number;
  name: string;
  status: number;
  transport_names: string[];
}

export class ServiceProviderFilter {
  id?:number;
  name?: string;
  transport?: string[];
  status?: number;
  page_number: number = 1;
}

export interface ServiceProviderItem {
  id?:number,
  name:string,
  status:number,
  transport_names?:string[],
  transports?:ProviderTransportItem[],
  transport_ids?:number[],
  sms_protocol_id?:number,
  call_protocol_id?:number,
  email_protocol_id?:number,
  viber_protocol_id?:number,
  whatsapp_protocol_id?:number,
  custom_protocol_id?:number,
  mn_protocol_id?:number,
  parameters?:ParameterItem[],
}

export interface ProviderTransportItem {
  id: number,
  name?: string,
  protocol_id?: number,
  protocol_name?: string,
}

export interface ParameterItem {
  protocol_id?: number,
  protocol_name?: string,
  protocol_parameter_id: number,
  provider_parameter_id?: number,
  name?: string,
  value?: string,
}

export class ServiceProviderItemImpl implements ServiceProviderItem{
  name: string;
  status: number;
  parameters:ParameterItem[];
  transport_ids:number[];
  sms_protocol_id?:number;
  call_protocol_id?:number;
  email_protocol_id?:number;
  viber_protocol_id?:number;
  whatsapp_protocol_id?:number;
  custom_protocol_id?:number;
  mn_protocol_id?:number;

  constructor() {
    this.name = "";
    this.status = 1;
    this.parameters = [];
    this.transport_ids = [];
  }
}
